// src/pages/projects/work-at-thinkmarkets.jsx
import "./projects.css";
import SectionMediaRight from "../../components/section-templates/SectionMediaRight";
import BentoBoxSection from "../../components/section-templates/BentoBoxSection";
import CardTextSection from "../../components/section-templates/CardTextSection";
import VideoGridSection from "../../components/section-templates/VideoGridSection";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";

export default function WorkAtThinkMarkets() {
  // 4 GIFs/images for the bento grid
  const gallery = [
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/promo-charts.webp",
      alt: "First",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/hand-animation.webp",
      alt: "Second",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/trading-view.webp",
      alt: "Third",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/btc-halving.webp",
      alt: "Fourth (wide)",
    },
  ];

  // VIDEOS

  const videos = [
    {
      title: "15 year anniversary of ThinkMarkets",
      src: "https://www.youtube.com/watch?v=qrxsG_7DPPQ",
      description: "Anniversary celebration of TM. Awareness campaign.",
      tags: ["After Effects", "Blender", "Premiere", "Audition"],
    },
    {
      title: "Appstore / Playstore Animation",
      src: "https://www.youtube.com/watch?v=aA--1k1lrcM",
      description: "AppStore and Playstore trailer.",
      tags: ["Blender", "After Effects"],
    },
    {
      title: "ThinkTrader Promo",
      src: "https://www.youtube.com/watch?v=-9xs_PJr3_E",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "Dynamic Leverage Explainer",
      src: "https://www.youtube.com/watch?v=2z35kyfPBus",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "BTC Halving Explainer",
      src: "https://www.youtube.com/watch?v=VIF5bGccNgk",
      description: "Explaining the Bitcoin halving event.",
      tags: ["Premiere Pro", "After Effects", "Photoshop", "Illustrator"],
    },
    {
      title: "TM X TV Promo",
      src: "https://www.youtube.com/watch?v=TxjO_5Ij93w",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    // …add as many as you like…
  ];

  // REMOVE VALUE BELOW
  // This is the metric data for the CardTextSection

  // Data for the full-width biaxial chart inside CardTextSection

  return (
    <>
      <MotionContainer className="container thinkmarkets-page">
        {/* Spacer */}
        <MotionItem className="thinkmarkets-spacer" />

        {/* Title */}
        <MotionItem delayChildren={0.02} className="main-title">
          My contribution at CoinTelegraph
        </MotionItem>

        {/* Overview & Approach */}
        <div className="info-columns">
          <MotionItem delayChildren={0.02} className="info-block">
            <h2>Page Under construction</h2>
          </MotionItem>
        </div>

        {/* Full-width media */}
      </MotionContainer>
    </>
  );
}
